import React, { useEffect } from "react";
import { ALL_ICONS } from "../../assets/icons/AllIcons";
import "../../styles/layout/AuthLayoutIndex.css";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../routes/AllRoutes";

interface myComponentProps {
  children?: React.ReactNode;
  title?: string;
  text?: string;
  back?: boolean;
  onBack?: () => void;
}

const AuthLayoutIndex = ({
  children,
  text,
  title,
  back,
  onBack,
}: myComponentProps) => {
  const navigate = useNavigate();
  useEffect(() => {
    const toks = localStorage?.getItem("token");
    if (toks) {
      navigate(ALL_ROUTES?.DASHBOARD_OVERVIEW);
    }
  }, []);

  return (
    <div className="auth-layout-index-wrapper-box">
      <div className="inner-box-wrapper">
        {/* logo start here  */}
        <div className="logo-box">
          <figure className="img-box">{ALL_ICONS?.smart_send_logo}</figure>
        </div>
        {/* logo end here */}
        {/* content wrap start */}
        <div className="inner-content-box">
          <div className="title-text-back-box">
            {back && (
              <>
                <div
                  onClick={() => {
                    onBack?.();
                  }}
                  className="back-box"
                >
                  <div className="icon-box">
                    <FaChevronLeft className="icon" />
                  </div>
                  <p className="text">Back</p>
                </div>
              </>
            )}
            <div className={`title-text-box ${back && "title-text-box-two"}`}>
              {title && (
                <p className="title">
                  {title || "Time to set a secure password"}
                </p>
              )}
              {text && (
                <>
                  {text?.split("\n")?.map((chi, idx) => {
                    return (
                      <p key={idx} className="text">
                        {chi}
                      </p>
                    );
                  })}
                </>
              )}
            </div>
          </div>

          {/* title text end */}

          {/* content-wrap start */}
          <div className="content-wrap">{children}</div>
          {/* content-wrap end */}
        </div>
        {/* content wrap end */}
      </div>
    </div>
  );
};

export default AuthLayoutIndex;
